export default __webpack_public_path__ + "static/media/lpimage3.836ac638.jpg";